import { Component, OnDestroy, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';

import * as Services from '@shared/core/services';
import { Controllers } from '@shared/core/controllers';
import { ScrollService } from '@shared/core/directives/scroll/scroll.shared.service';

import { ModalViewComponent } from '../modal-view.shared.component';

@Component({
    selector: 'shared-modal-for-credit-card-add',
    templateUrl: './modal-for-credit-card-add.shared.component.html',
    styleUrls: ['./modal-for-credit-card-add.shared.component.scss']
})
export class ModalForCreditCardAddComponent extends ModalViewComponent implements OnInit, OnDestroy {
    public paymentProvider: OLO.Enums.PAYMENT_PROVIDER;
    @Input() public preTitle: string = 'PAYMENT METHOD';
    @Input() public title: string = 'Add a credit card';
    @Input() public delay: number = 500; /* Form submit delay - wait for modal to be closed */
    @Input() public labelSubmit: string = 'Add card';

    constructor(
        public modalsService: Services.ModalsService,
        public heightAdjustService: Services.HeightAdjustService,
        public scrollService: ScrollService,
        public controllers: Controllers,
    ) {
        super(modalsService, heightAdjustService, scrollService);

        this.size = 'sm';
    }

    ngOnInit(): void {
        this.paymentProvider = this.controllers.payment.paymentProvider();

    }

    ngOnDestroy(): void {

    }

    public handleFormSubmit(data: { event: Event; form: FormGroup; }): void {
        /* Will close modal, but form will be submitted with delay */
        if (this.paymentProvider === OLO.Enums.PAYMENT_PROVIDER.PAYMENT_EXPRESS) return;
        this.handleCloseClick(null);
    }

    public get isCommonType(): boolean {
        return this.controllers.payment.isCommonType;
    }

    public get isRedirectType(): boolean {
        return this.controllers.payment.isRedirectType;
    }

    public get isProviderFormType(): boolean {
        return this.controllers.payment.isProviderFormType;
    }
}
